var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-container',{staticClass:"mt-4",attrs:{"fluid":""}},[_c('v-row',[_c('v-spacer')],1),_c('v-row',[_c('AddressInput',{attrs:{"label":_vm.$t('address'),"disabled":!_vm.isAdmin},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }